import React from 'react';
import PropTypes from 'prop-types';
import { OptionSelector } from 'components';

const BooleanOption = ({ name, onChange, value }) => {
  const values = [
    { value: true, label: 'true' },
    { value: false, label: 'false' }
  ];

  return (
    <li className="line-row">
      <span>
        {name}:
        <OptionSelector
          name={name}
          onChange={onChange}
          options={values}
          value={value}
        />
      </span>
    </li>
  );
};

BooleanOption.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired
};

export default BooleanOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/BooleanOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/BooleanOption.js